import { render } from "./UserView.vue?vue&type=template&id=9f80da5c"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__